<template>
  <v-card>
    <v-expansion-panel>
      <v-expansion-panel-content v-for='p in parameters' :key='p'>
        <div slot='header' @click='parameter = p'>{{p}}</div>
        <v-select :items='stations' v-model='station'></v-select>
        <v-list>
          <v-list-tile v-for='t in tsparams' :key='t'>{{t}}</v-list-tile>
        </v-list>
      </v-expansion-panel-content>
    </v-expansion-panel>
  </v-card>
</template>

<script>
  export default {
    data() {
      return {
        editing: false,
        parameter: {},
        parameters: [],
        tsparameters: [],
        headers: [
          { text: 'Identifier', align: 'left', value: 'Identifier' },
          { text: 'Station', align: 'left', value: 'StationName' },
          { text: 'Decimals', align: 'left', value: 'NumberOfDecimalPoint' },
        ],
        selected: {},
        search: '',
        station: '',
        loading: true,
      }
    },
    computed: {
      stations() {
        return this.tsparameters.filter(p => p.Identifier.includes(this.parameter)).map(p => p.StationName).sort()
      },
      tsparams() {
        return this.tsparameters.filter(p => p.StationName === this.station && p.includes(this.parameter))
      },
    },
    methods: {
      edit(item) {
        this.selected = item
        this.editing = true
      },
      save() {
        // TODO
      },
    },
    mounted() {
      this.axios.get('/api/AdminAPI/GetAquariusParameters').then(res => {
        this.parameters = res.data.slice(0, 20).sort()

        this.axios.get('/api/AdminAPI/GetParameters').then(res => {
          this.loading = false
          this.tsparameters = res.data.slice(0, 50)
        })
      })
    },
  }
</script>

<style scoped>
  tbody tr {
    cursor: pointer;
  }

  tbody:hover tr:hover {
    background: #eee;
  }
</style>
